import { Link } from 'react-router-dom';

export default function RecruitCTA() {
  return (
    <section className="py-24 bg-gradient-to-br from-cyan-50 via-cyan-100/50 to-blue-50 observe-animation opacity-0">
      <div className="container mx-auto px-6 lg:px-12">
        <div className="max-w-5xl mx-auto bg-white rounded-3xl shadow-2xl p-12 lg:p-16 text-center">
          <div className="mb-6">
            <span className="text-cyan-500 text-sm font-semibold tracking-wider uppercase">Recruit</span>
          </div>
          
          <h2 className="text-4xl lg:text-6xl font-bold text-gray-900 mb-8">
            一緒に働きませんか？
          </h2>

          <p className="text-xl lg:text-2xl text-gray-700 leading-relaxed mb-4">
            未経験の方も大歓迎です。
          </p>
          <p className="text-lg text-gray-600 leading-relaxed mb-12">
            充実した研修制度と温かいチームで、あなたの成長をサポートします。<br />
            まごころを持って、地域の方々の暮らしを支える仕事を始めませんか。
          </p>

          <Link
            to="/recruit"
            className="inline-flex items-center gap-3 px-12 py-5 bg-cyan-500 text-white rounded-full font-bold text-xl hover:bg-cyan-600 transition-all duration-300 shadow-xl hover:shadow-2xl hover:-translate-y-1 whitespace-nowrap cursor-pointer"
          >
            採用情報を詳しく見る
            <i className="ri-arrow-right-line text-2xl"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}
